import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import config from "./aws-exports";
import customConfig from "./custom-config";
import { Amplify } from "aws-amplify";
import { LicenseInfo } from '@mui/x-license';


// Soft UI Context Provider
import { TemplateControllerProvider } from "context";

// react-perfect-scrollbar component
import PerfectScrollbar from "react-perfect-scrollbar";

// react-perfect-scrollbar styles
import "react-perfect-scrollbar/dist/css/styles.css";
import RefreshProvider from "layouts/dashboard/refreshProvider";

Amplify.configure({
  ...config,
  ...customConfig,
});

LicenseInfo.setLicenseKey(process.env.REACT_APP_ENV_MUIX_KEY ? process.env.REACT_APP_ENV_MUIX_KEY : 'YOUR_LICENSE_KEY');

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <TemplateControllerProvider>
      <RefreshProvider>
      <App />
      </RefreshProvider>
    </TemplateControllerProvider>
  </BrowserRouter>
);
